
import React from "react";
import { Badge } from "@/components/ui/badge";
import { InvoiceStatus } from "@/types/constants";

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}

const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status }) => {
  const getVariant = () => {
    switch (status) {
      case "paid":
        return "success";
      case "unpaid":
        return "warning";
      case "overdue":
        return "destructive";
      case "partial":
        return "info";
      case "draft":
        return "muted";
      case "void":
        return "outline";
      default:
        return "muted";
    }
  };

  return (
    <Badge variant={getVariant()} className="font-medium">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>
  );
};

export default InvoiceStatusBadge;
